import type { InboxDemoData } from "./types";

export const supportDemo: InboxDemoData = {
  navigation: {
    title: "Inbox",
    notificationCount: 2,
    userName: "Mina",
    planBadge: "PRO",
  },
  selectedGroupId: "all",
  groups: [
    { id: "all", label: "📬 全部消息" },
    { id: "ai", label: "🤖 AI 处理中", showCount: true },
    { id: "pending", label: "👤 待人工接入", showCount: true },
    { id: "mine", label: "🙋 我负责的", showCount: true },
    { id: "closed", label: "✅ 已关闭" },
    {
      id: "channels",
      label: "渠道",
      collapsible: true,
      defaultExpanded: true,
      children: [
        {
          id: "wecom",
          label: "企业微信",
          iconKey: "wecom",
          collapsible: true,
          defaultExpanded: true,
          children: [{ id: "wecom-support", label: "品牌客服" }],
        },
        {
          id: "email",
          label: "邮箱",
          iconKey: "email",
          collapsible: true,
          defaultExpanded: true,
          children: [{ id: "email-support", label: "support@brand.com" }],
        },
        {
          id: "xiaohongshu",
          label: "小红书",
          iconKey: "xiaohongshu",
          collapsible: true,
          defaultExpanded: true,
          children: [{ id: "xhs-official", label: "official.shop" }],
        },
      ],
    },
  ],
  conversations: [
    {
      id: "support-1",
      name: "Lina Chen",
      avatarInitial: "L",
      avatarTone: "primary",
      preview: "订单还没发货，能帮我查一下吗？",
      timestamp: "2m",
      channel: "小红书",
      channelKey: "xiaohongshu",
      groupId: "all",
      status: "ai",
      messages: [
        {
          id: "s1-m1",
          sender: "customer",
          senderName: "Lina Chen",
          content: "订单还没发货，能帮我查一下吗？",
          timestamp: "15:02",
          dateLabel: "Today  15:02",
        },
        {
          id: "s1-m2",
          sender: "ai",
          senderName: "Support Agent",
          content: "我先帮你核对物流。订单 #3821 今天 16:00 前会出仓。",
          timestamp: "15:02",
        },
      ],
    },
    {
      id: "support-2",
      name: "Omar@retail.com",
      avatarInitial: "O",
      avatarTone: "success",
      preview: "Can I change the shipping address?",
      timestamp: "18m",
      channel: "邮箱",
      channelKey: "email",
      groupId: "email",
      status: "mine",
      messages: [
        {
          id: "s2-m1",
          sender: "customer",
          senderName: "Omar",
          content: "Can I change the shipping address?",
          timestamp: "14:44",
          dateLabel: "Today  14:44",
        },
        {
          id: "s2-m2",
          sender: "human",
          senderName: "Mina",
          content: "Yes, send the new address and I will update it before fulfillment.",
          timestamp: "14:45",
        },
      ],
    },
    {
      id: "support-3",
      name: "Nara",
      avatarInitial: "N",
      avatarTone: "danger",
      preview: "这个颜色还有货吗？",
      timestamp: "1h",
      channel: "抖音",
      channelKey: "tiktok",
      groupId: "ai",
      status: "pending",
      messages: [
        {
          id: "s3-m1",
          sender: "customer",
          senderName: "Nara",
          content: "这个颜色还有货吗？",
          timestamp: "13:10",
          dateLabel: "Today  13:10",
        },
        {
          id: "s3-m2",
          sender: "ai",
          senderName: "Support Agent",
          content: "沙色 M 码还有 6 件，要帮你锁库存吗？",
          timestamp: "13:10",
        },
      ],
    },
  ],
};
